// Supplied WhatsApp launcher only. Contains no agent/session context or secrets.
// A single loader per document also covers route changes and StrictMode remounts.
export function loadWatiWidget(enabled: boolean): void {
  if (!enabled || document.getElementById('scholarvest-wati-script')) return;
  // Override the vendor's fixed 20px margin with mobile browser/safe-area clearance.
  const style = document.createElement('style');
  style.id = 'scholarvest-wati-position';
  style.textContent = `
    #whatsapp-chat-widget { --wati-clearance: 20px; }
    #whatsapp-chat-widget .wa-widget-send-button {
      margin-bottom: 0 !important;
      bottom: calc(var(--wati-clearance) + env(safe-area-inset-bottom, 0px) + var(--wati-viewport-inset, 0px)) !important;
      right: max(20px, env(safe-area-inset-right, 0px)) !important;
    }
    #whatsapp-chat-widget .wa-chat-bubble,
    #whatsapp-chat-widget .wa-chat-box {
      bottom: calc(var(--wati-clearance) + env(safe-area-inset-bottom, 0px) + var(--wati-viewport-inset, 0px)) !important;
    }
    #whatsapp-chat-widget .wa-chat-box {
      max-height: calc(100dvh - var(--wati-clearance) - 120px);
      overflow-y: auto;
    }
    @media (max-width: 767px) {
      #whatsapp-chat-widget { --wati-clearance: 72px; }
      body:has(#whatsapp-chat-widget) { padding-bottom: calc(148px + env(safe-area-inset-bottom, 0px)); }
    }
  `;
  document.head.appendChild(style);
  const viewport = window.visualViewport;
  if (viewport) {
    let frame = 0;
    const updatePosition = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        // At normal zoom, account for browser chrome and the on-screen keyboard.
        const inset = viewport.scale === 1
          ? Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop)
          : 0;
        document.documentElement.style.setProperty('--wati-viewport-inset', `${inset}px`);
      });
    };
    viewport.addEventListener('resize', updatePosition, { passive: true });
    viewport.addEventListener('scroll', updatePosition, { passive: true });
    updatePosition();
  }
  const script = document.createElement('script');
  script.id = 'scholarvest-wati-script';
  script.src = 'https://wati-integration-prod-service.clare.ai/v2/watiWidget.js?62666';
  script.async = true;
  script.referrerPolicy = 'no-referrer';
  script.onload = () => {
    const create = (window as unknown as { CreateWhatsappChatWidget?: (options: unknown) => void }).CreateWhatsappChatWidget;
    if (!create) return;
    try {
      create({
        enabled: true,
        chatButtonSetting: { backgroundColor: '#116db4', ctaText: 'Chat with us', borderRadius: '25', marginLeft: '0', marginRight: '20', marginBottom: '20', ctaIconWATI: true, position: 'right' },
        brandSetting: { brandName: 'Scholarvest', brandSubTitle: '', welcomeText: 'Hi there!\nHow can we help you?', messageText: '', backgroundColor: '#116db4', ctaText: 'Chat with us', borderRadius: '25', autoShow: false, phoneNumber: '2349127352398' },
      });
    } catch { /* Vendor failure must not interrupt the application. */ }
  };
  script.onerror = () => { /* Leave marker to avoid retry storms during navigation. */ };
  document.head.appendChild(script);
}
